import Component from '../core/Component'


export default class SampleConditions extends Component {
    constructor(element,options={}) {
        super(element,options)

        this.ref = {
            text: null,
            button: null
        }
    }
    
    prepare() {
        this.ref.button.addEventListener('click', this.handleClick)
    }

    handleClick = () => {
        this.ref.text.classList.toggle("is-active")
        this.ref.button.classList.toggle("is-active")
    }

}